import { IWorkflowEvents } from '@llws/lift-entity-interfaces';
import { ActionContext } from 'vuex';
import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IStateStrict } from '@/shared/interfaces/store-base';
import { TRootState } from '..';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { IFilterPayloadV2 } from '@/shared/interfaces/filter-payload-v2';

const adminGatewayResourcePath: string = '/client-api/workflow_events';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

const base = new StoreBaseImplementationV2<IWorkflowEvents>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
    get: async (ctx: ActionContext<IStateStrict<IWorkflowEvents>, TRootState>, payload: IFilterPayloadV2) => {
      await base.actions.get(ctx, payload);
    },
  },
};
